export const TableEmptyState = ({ children }: { children: string }) => {
	return (
		<p className="whitespace-pre-wrap px-4 py-8 text-center text-sm text-gray-500">
			{children}
		</p>
	)
}
